// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"251":"d9e5d4de","348":"c4cd2727","354":"6f88fa32","731":"d9e5d4de","843":"d9e5d4de"}[chunkId] + ".chunk.css";
};